import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function LoansBookedReportScreen() {
  return (
    <PlaceholderScreen
      icon="📋"
      title="Loans Booked Report"
      subtitle="This report shows new loan disbursements with customer details, amounts, and dates. This report will be available in a future update."
    />
  )
}
